import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs} from "firebase/firestore";
const db = getFirestore(firebaseApp);

    

export default async function getbotones_gastos() {
    const BotonesDB =  [];
    console.log("Gastos");
    const collectionRef = collection(db, "Botones_gastos/");
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      BotonesDB.push(doc.data());
    });
    return BotonesDB;
}